import { EvergreenPage } from '../components/seo/EvergreenPage'
import { PUBLIC_STATUS_PAGES_SECTIONS } from '../content/seo/publicStatusPages'
import { articleJsonLd } from '../seo/structuredData'
import { PAGE_META } from '../seo/pageMeta'

const meta = PAGE_META['/public-status-pages']

export function PublicStatusPagesPage() {
  return (
    <EvergreenPage
      path="/public-status-pages"
      title="Public status pages for your customers"
      lead="Share uptime with customers on a branded status page with monitor lists, uptime percentages, and live charts."
      sections={PUBLIC_STATUS_PAGES_SECTIONS}
      jsonLd={articleJsonLd({
        title: meta.title,
        description: meta.description,
        path: '/public-status-pages',
      })}
    />
  )
}
